export const POLICY_THEOCRACY_MELEE_BONUS = 1;

export const POLICY_THEOCRACY_BUILDING_DISCOUNT_TEMPLE = 0;

export const POLICY_THEOCRACY_TEMPLE_WIN_POINTS_INCOME_BONUS = 2;



